
namespace TabAurous.ProductDevelopment {
    @Serenity.Decorators.registerClass()
    export class DesigningItemsEditorForPD extends _Ext.GridEditorBase<CustomerRequirementItemsRow> {
        protected getColumnsKey() { return "ProductDevelopment.CustomerRequirementItems"; }
        protected getDialogType() { return CustomerRequirementItemsDialogForPD; }
        protected getLocalTextPrefix() { return CustomerRequirementItemsRow.localTextPrefix; }
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            opt.EnableQuickSearch = true;
            return opt;
        }
        constructor(container: JQuery) {
            super(container);

            this.slickGrid.setOptions({ rowHeight: 30 });

        } 

        //protected getColumns() {

        //    var columns = super.getColumns();
        //    columns.push(
        //        {
        //            field: 'Action',
        //            name: '',
        //            format: ctx => '<button class="inline-action btn-success change-status" style="width:100%;">Send to Designing</button>',
        //            width: 90,
        //            minWidth: 90,
        //            maxWidth: 90
        //        });

        //    return columns;
        //}
        //protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //    super.onClick(e, row, cell);


        //    if (e.isDefaultPrevented())
        //        return;

        //    var item = this.itemAt(row);
        //    var target = $(e.target);

        //    // if user clicks "i" element, e.g. icon
        //    if (target.parent().hasClass('inline-action'))
        //        target = target.parent();

        //    if (target.hasClass('inline-action')) {
        //        e.preventDefault();
        //        if (target.hasClass('change-status')) {
        //            CustomerRequirementItemsService.UpdateStatus({ EntityId: item.TransItemId },
        //                response => {
        //                    if (response.EntityId == item.TransItemId)
        //                        this.refresh();
        //                }, { async: false })
        //        }
        //        if (target.hasClass('edit numeric')) {
        //            super.onClick(e, row, cell);
        //        }
        //    }
        //}
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        } 
        setData(Items) {
            this.view.setItems([]);
            for (let item of Items) {

                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);

            }
        }
        protected getQuickFilters() {
            let filters = super.getQuickFilters();
            //filters.push({
            //    type: Serenity.LookupEditor,
            //    options: {
            //        lookupKey: OMS.FinancialYearRow.lookupKey,
            //        multiple: true

            //    },
            //    field: 'FinancialYearId',
            //    title: 'Year',
            //    handler: w => {
                     
            //    },

            //    cssClass: 'hidden-xs'
            //});
            return filters;
        }
    }
}